import React, { Fragment } from "react";
import { IntlProvider } from "react-intl";
import PropTypes from "prop-types";
import { LOCALES } from "./LOCALES";
import content from "./content";

const Provider = ({ children, locale }) => (
  <IntlProvider
    locale={locale}
    textComponent={Fragment}
    messages={content[locale]}
  >
    {children}
  </IntlProvider>
);

Provider.displayName = "I18nProvider";

Provider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  locale: PropTypes.oneOf(Object.values(LOCALES)),
};

Provider.defaultProps = {
  locale: LOCALES.ENGLISH,
};

export default Provider;